<template>
  <div @click="showCrimeTree = false" class="container" v-loading="initLoading">
    <div class="course-panel">
      <div class="course-panel-body">
        <!-- <div class="desc">
          <span class="label">课题数据筛选</span>
          <span class="word">（建议选择3-5个条件筛选课题的数据范围）</span>
        </div> -->
        <div class="condition-panel">
          <div class="condition-item" v-for="(courseTipItem, courseTipIndex) in courseFilterTips" :key="courseTipIndex">
            <span>{{ courseTipItem.tipText }}</span>
            <template v-if="courseTipItem.filterItem.name !== '文书类型'">
              <i
                v-if="['全文检索', '引用法条'].includes(courseTipItem.filterItem.name)"
                class="el-icon-close close-btn"
                @click="
                  removeFilter({
                    filterItem: courseTipItem.filterItem,
                    contentArr: courseTipItem.contentArr,
                    id: courseTipItem.id
                  })
                "
              ></i>
              <i
                v-else
                class="el-icon-close close-btn"
                @click="removeFilter({ filterItem: courseTipItem.filterItem })"
              ></i>
            </template>
          </div>
        </div>
        <div class="course-panel-item">
          <span class="label">文书类型</span>
          <div class="course-panel-item-wrapper">
            <el-radio-group class="input" v-model="instrumentType" @change="refreshFilterOptions()">
              <el-radio v-for="wayText in sysDataWays" :key="wayText" :label="wayText">
                <span>{{ wayText }}</span>
                <span v-if="wayText === '行政处罚文书'">(暂不支持导入)</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div
          class="course-panel-item"
          v-for="label in filterList"
          :key="label.uniqueId"
          :style="label.mulits ? 'display: flex; flex-wrap: wrap;' : ''"
        >
          <template>
            <span class="label" v-if="(label.mulits && label.result.length > 0) || !label.mulits">{{
              label.name
            }}</span>
            <div
              class="course-panel-item-wrapper"
              v-if="['version', 'base_title', 'base_caseNumber', 'counterpart', 'penaltyBasis', 'title', 'caseNo'].includes(label.key)"
            >
              <div class="input">
                <el-input
                  :style="{ width: selectWidth }"
                  clearable
                  v-model="label.value"
                  :placeholder="label.placeholder || '请输入关键词'"
                />
              </div>
              <span
                class="operation"
                :style="{ margin: '0 0 0 7px' }"
                v-if="label.edit"
                @click.stop="removeFiled(label)"
                ><i class="el-icon-remove-outline"></i
              ></span>
            </div>
            <div
              v-else-if="label.name == '全文检索' && label.result.length > 0"
              class="panel-item-warp"
              style="margin-top: 20px"
            >
              <fullTextSelect :label="label" :instrumentType="instrumentType" />
            </div>

            <div v-else-if="['案由'].includes(label.name) && isInit" class="panel-item-warp">
              <fullReasonSelect :label="label" />
            </div>
            <div v-else-if="['引用法条'].includes(label.name)" class="panel-item-warp">
              <div
                v-for="(val, index) in label.result"
                :key="index"
                class="input para-search"
                style="margin: 2px 7px 2px 4px"
              >
                <el-select
                  class="left-select"
                  v-model="val.keyword"
                  :style="{ width: '144px' }"
                  clearable
                  filterable
                  default-first-option
                  popper-class="pop-select"
                  placeholder="全部法律"
                  @change="(val.value = ''), (val.lawRes = [])"
                >
                  <el-option-group v-for="group in selectRelationOptions.lawViews" :key="group.id" :label="group.key">
                    <el-option v-for="item in group.title.buckets" :key="item.id" :value="item.key">
                      <span slot="label">{{ item.key }}</span>
                    </el-option>
                  </el-option-group>
                </el-select>

                <el-select
                  class="right-select"
                  v-model="val.value"
                  clearable
                  filterable
                  default-first-option
                  remote
                  :placeholder="!val.keyword ? '请先选择法律' : '输入法条关键词搜索，多关键词用空格隔开'"
                  :style="{ width: '356px', marginRight: '7px' }"
                  :remote-method="e => remoteMethod(e, val)"
                  :loading="remoteLoading"
                  popper-class="law-pop-select"
                  :disabled="!val.keyword"
                >
                  <el-option v-for="item in val.lawRes" :key="item.id" :label="item.lawTitle" :value="item.lawTitle">
                    <div>{{ item.lawTitle }}</div>
                    <div class="single-ellipsis">
                      <span
                        v-for="(content, contentIdx) in item.highlight.lawContent"
                        :key="contentIdx"
                        v-html="content"
                      >
                      </span>
                    </div>
                  </el-option>
                </el-select>

                <span class="operation" @click="addRes(label)"><i class="el-icon-circle-plus-outline"></i></span>
                <span class="operation" @click="removeRes(label, index)"><i class="el-icon-remove-outline"></i></span>
              </div>

              <div class="text-group-type" v-if="label.result.length > 1">
                <div slot="reference" class="group-type-btn">
                  <span @click="label.type = 'and'" class="group-text" :class="[label.type === 'and' ? 'active' : '']"
                    >且</span
                  >
                  <span @click="label.type = 'or'" class="group-text" :class="[label.type === 'or' ? 'active' : '']"
                    >或</span
                  >
                </div>
              </div>
              <div class="line" v-if="label.result.length > 1">
                <span class="line-item line-item-top"></span>
                <span class="line-item line-item-bottom"></span>
              </div>
            </div>
            <div class="course-panel-item-wrapper" v-else>
              <el-cascader
                v-if="label.inputType == 'province_city_cascader'"
                popper-class="province-city-cascader"
                v-model="label.value"
                :style="{ width: selectWidth }"
                :options="label.data"
                :props="label.optionProps"
                clearable
                filterable
                :show-all-levels="false"
                @change="changeCascaderHandle(label.key)"
                placeholder="请输入搜索或选择"
                :ref="label.key"
              />
              <div :style="{ width: selectWidth }" style="display: inline-block" v-if="label.key == 'full_base_court'">
                <configureRemoteSelect
                  :ref="label.key"
                  :item="label"
                  :type="label.key"
                  :checkAllName="label.checkAllName"
                  :relationParent="courtLevel"
                  @valueChange="remoteSelectChange"
                />
              </div>
              <div :style="{ width: selectWidth }" style="display: inline-block" v-else-if="label.key == 'districtIds'">
                <configureRemoteSelect
                  :ref="label.key"
                  :item="label"
                  :type="label.key"
                  :checkAllName="label.checkAllName"
                  @valueChange="remoteSelectChange"
                />
              </div>
              <template v-else-if="label.inputType === 'mulit_personal_crime'">
                <el-checkbox
                  class="personal-crime-checkbox"
                  v-model="label.value.singlePersonal"
                  label="单主体"
                  border
                />
                <el-checkbox
                  class="personal-crime-checkbox"
                  v-model="label.value.mulitPersonal"
                  label="多主体"
                  border
                />
                <el-checkbox class="personal-crime-checkbox" v-model="label.value.singleCrime" label="单案由" border />
                <el-checkbox class="personal-crime-checkbox" v-model="label.value.mulitCrime" label="多案由" border />
              </template>
              <el-select
                v-else-if="label.key == 'base_nature'"
                v-model="label.value"
                :style="{ width: selectWidth }"
                clearable
                filterable
                default-first-option
                multiple
                @change="multSelectHandle(label.key)"
                :ref="label.key"
                placeholder="请输入搜索或选择"
              >
                <el-option v-for="(val, valIndex) in natureList" :key="valIndex" :value="val"> </el-option>
              </el-select>
              <el-cascader
                v-else-if="label.key == 'base_caseType'"
                :key="label.key"
                :style="{ width: selectWidth }"
                class="crime-select"
                v-model="label.value"
                :options="selectRelationOptions.base_caseType"
                :props="{ multiple: false, label: 'name', value: 'name', expandTrigger: 'hover' }"
                :show-all-levels="false"
                @change="changeCaseType(label.value)"
                label="name"
                clearable
              >
              </el-cascader>
              <div :style="{ width: selectWidth }" v-else-if="label.key == 'full_procedureType'">
                <configureRemoteSelect
                  v-if="isInit"
                  :ref="label.key"
                  :relationParent="casePickType"
                  :item="label"
                  :type="label.key"
                  :checkAllName="label.checkAllName"
                  @valueChange="remoteSelectChange"
                  @reset="label.resetFunc()"
                />
              </div>
              <el-select
                v-else-if="label.inputType == 'select'"
                v-model="label.value"
                :style="{ width: selectWidth }"
                clearable
                filterable
                default-first-option
                multiple
                @change="multSelectHandle(label.key)"
                :ref="label.key"
                placeholder="请输入搜索或选择"
              >
                <el-option
                  v-for="(val, index) in ((label.data || []).length > 0 ? label.data : selectRelationOptions[label.key]) || []"
                  :key="index"
                  :value="val"
                />
              </el-select>

              <div v-if="label.inputType == 'date'">
                <el-date-picker
                  :style="{ width: '239px' }"
                  v-model="label.value[0]"
                  type="date"
                  :default-value="defaultDate"
                  :picker-options="{ disabledDate: disabledDateHandle }"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span> 至 </span>
                <el-date-picker
                  :style="{ width: '238px' }"
                  v-model="label.value[1]"
                  type="date"
                  :default-value="defaultDate"
                  :picker-options="{ disabledDate: disabledDateHandle }"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </div>

              <!-- <el-autocomplete
                v-model="label.value"
                popper-class="cirme-input-popper"
                v-if="label.key == 'base_caseNumber'"
                :style="{ width: selectWidth }"
                clearable
                :fetch-suggestions="(str, cb) => cb([true])"
                placeholder="请输入案号"
                :maxlength="300"
              >
                <div class="course-create-input-tip" @click.stop="() => ''">
                  <div class="course-create-input-tip-title">输入提示：</div>
                  <div class="course-create-input-tip-item">
                    “|”竖线的符号表示“或”的关系（如：（2020）豫1727民初4571号 |（2021）吉0523民初46号）
                  </div>
                </div>
              </el-autocomplete> -->

              <span
                class="operation"
                :style="{ margin: '0 0 0 7px' }"
                v-if="label.edit"
                @click.stop="removeFiled(label)"
                ><i class="el-icon-remove-outline"></i
              ></span>
            </div>
            <div class="course-panel-item-tip" v-if="label.tipText">
              <span>{{ label.tipText }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="course-panel-menu">
      <div class="menu-title">添加标签</div>
      <div class="new-filter-ul">
        <div
          class="new-filter-item"
          v-for="(field, index) in filedList"
          :key="index"
          @click="addFields(field)"
          :class="hadFileds(field) ? 'disabled-filter-item' : ''"
        >
          <span><i class="el-icon-plus"></i></span>
          <span>{{ field.name }}</span>
        </div>
      </div>
    </div>
    <div class="normal-footer">
      <div>
        <span>全库案例数： {{ totalCount | formatTotalCount }} 个</span>
        <template v-if="totalCount !== filterCount">
          <span class="filter-count">
            <span>筛选案例数：</span>
            <span class="blue" v-if="countLoading === 0">{{ filterCount | formatTotalCount }}</span>
            <span v-else><i class="el-icon-loading"></i></span>
            <span>个</span>
          </span>
          <span class="filter-count" v-if="false">
            <span>导入课题案例数：</span>
            <span class="green" v-if="courseLockSize >= filterCount">{{ filterCount.toLocaleString() }}</span>
            <span class="red" v-else>{{ courseLockSize.toLocaleString() }}</span>
            <span>个</span>
            <el-popover placement="top" width="300" trigger="hover" v-if="filterCount > courseLockSize">
              <div :style="{ padding: '10px' }">
                <span>由于系统支持最高的课题案例数为</span>
                <span>{{ courseLockSize.toLocaleString() }}</span>
                <span>个。当案例数超过了限制数，系统将会按照文书日期最近开始排序推送</span>
                <span>{{ courseLockSize.toLocaleString() }}</span>
                <span>个案例导入课题</span>
              </div>
              <i slot="reference" class="el-icon-question question-icon"></i>
            </el-popover>
          </span>
        </template>
      </div>
      <div>
        <el-button type="primary" :disabled="totalCount === filterCount" @click="showTipHandle()">
          <span>立即创建课题</span>
        </el-button>
      </div>
    </div>

    <course-creater-pay
      v-if="payModal.show"
      :show.sync="payModal.show"
      :lockTotal="payModal.lockTotal"
      :caseTotal="payModal.caseTotal"
      :loading="saveCoursewareLoading"
      :instrumentType="instrumentType"
      @confirm="saveCoursewareHandle"
    />
  </div>
</template>

<script>
import courseCreaterPay from '@/components/courseCreater/courseCreaterPay';

import { services } from '@/service';
import { arrayToTree, fetchCourseFilterTips } from '@/lib/utils';
import { find, findIndex } from 'lodash';
import provinceJson from '@/assets/area/province_city';
import { uniqueId, debounce, cloneDeep, groupBy } from 'lodash';
import dayjs from 'dayjs';
import { baseNature, procuratorateNature, sysCaseWays, sysDataWays, dayUnixValue } from '@/constant';
import configureRemoteSelect from '@/components/configureRemoteSelect';
import fullTextSelect from '@/components/fullTextSelect/index.vue';
import fullReasonSelect from '@/components/fullReasonSelect/index.vue';
import moment from 'moment';

// const limitDate = '2019-12-31';
// const limitDateUnix = dayjs(limitDate).unix();

function getFullReasonChild() {
  return {
    id: `${Date.now()}_${uniqueId()}`,
    value: [],
    showValue: []
  };
}

export default {
  components: {
    courseCreaterPay,
    configureRemoteSelect,
    fullTextSelect,
    fullReasonSelect
  },
  provide() {
    return {
      getQuery: () => this.getQuery()
    };
  },
  data() {
    return {
      isInit: false,
      selectWidth: '500px',
      initLoading: false,
      payModal: {
        lockTotal: 0,
        caseTotal: 0,
        show: false
      },
      filterModelLoading: false,
      countLoading: 0,
      countLoadingIdx: 0,
      instrumentType: '裁判文书',
      filterList: [],
      crimeTreeInited: false,
      remoteLoading: false,
      paragraphArr: [],
      showCrimeTree: false,
      totalCount: 0,
      filterCount: 0,
      saveCoursewareLoading: false,
      getFilterRes: [],
      filedList: [],
      defaultDate: dayjs(),
      casePickType: '',
      selectRelationOptions: {
        orgTypeNames: [],
        base_caseType: [],
        lawViews: []
      }
    };
  },
  props: {
    courseConditionArr: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    'payModal.show'(val) {
      this.$emit('tipShowHandle', val);
    },
    showCrimeTree(val) {
      if (!val) {
        this.crimeTreeInited = false;
        return false;
      }
      this.$nextTick(() => {
        this.initCrimeTreeCheck();
      });
    }
  },
  computed: {
    sysDataWays() {
      return sysDataWays;
    },
    courtLevel() {
      const courtItem = find(this.filterList, { name: '法院层级' });
      return (courtItem && courtItem.value) || [];
    },
    isAdmin() {
      return !!this.$store.getters.isAdmin;
    },
    courseLockSize() {
      return this.$store.state.authriozation.courseLockSize;
    },
    courseFilterTips() {
      return fetchCourseFilterTips({
        instrumentType: this.instrumentType,
        filterList: this.filterList,
        paragraphArr: this.paragraphArr
      });
    },
    paragraphArrGroup() {
      const groupObj = groupBy(this.paragraphArr, 'groups');
      return Object.keys(groupObj).map(groupName => {
        let arr = [];
        if (this.instrumentType === groupName) {
          arr = groupObj[groupName];
        }
        return { groupName, data: arr };
      });
    },
    natureList() {
      const arr = [
        {
          name: '裁判文书',
          key: 'base_nature',
          data: [...baseNature]
        },
        {
          name: '检察文书',
          key: 'procuratorate_nature',
          data: [...procuratorateNature]
        }
      ];
      const natureItem = arr.find(item => item.name === this.instrumentType);
      return (natureItem && natureItem.data) || [];
    },
    isCompanyCourse() {
      return this.modeVal === 'company';
    }
  },
  beforeDestroy() {
    this.filterWatcher && this.filterWatcher();
  },
  created() {
    this.refreshFilterOptions();
    
    this.initFilterDefaultVal();

    this.fetchAllCaseTotal();
    this.filterWatcher = this.$watch('filterList', {
      handler: function() {
        this.dataFilterHandle();
      },
      immediate: true,
      deep: true
    });
    
    this.dataFilterHandle = debounce(this.dataFilterHandle.bind(this), 200);
  },

  async mounted() {
    try {
      this.initLoading = true;
      [this.paragraphArr] = await Promise.all([
        services.labelRelation.getParagraphCourseFilter(),
        this.fetchLawData(),
        this.fetchCaseTypeList(),
        this.fetchOrgTypeNames()
      ]);
    } catch (err) {
      this.$error(err);
    } finally {
      this.isInit = true;
      this.initLoading = false;
    }
  },

  methods: {
    remoteSelectChange(item, value, showValue) {
      item.value = value;
      item.showValue = showValue;
    },
    changeCaseType(value) {
      this.casePickType = value[value.length - 1] || '';
      this.resetProcedure();
    },
    resetProcedure() {
      const item = find(this.filterList, { name: '审理程序' });
      item.value = [];
      this.$nextTick(() => {
        this.$refs[item.key][0].initValue();
      });
    },
    async initCrimeTreeCheck() {
      const crimeItem = find(this.filterList, { name: '案由' });
      if (crimeItem.value.length > 0) {
        this.$refs.cirmesTreeRef[0].setCheckedKeys(crimeItem.value);
      }
      await this.$nextTick();
      this.crimeTreeInited = true;
    },
    nodeCheckHandle(item, val) {
      if (!this.crimeTreeInited) {
        return;
      }
      const crimeItem = find(this.filterList, { name: '案由' });
      if (val) {
        const val = [...crimeItem.value, item.name];
        crimeItem.value = [...new Set(val)];
      } else {
        crimeItem.value = crimeItem.value.filter(name => name !== item.name);
      }
    },
    disabledDateHandle(date) {
      const unix = dayjs(date).unix();
      const limitUnix = dayjs().unix();
      if (unix > limitUnix) {
        return true;
      }
      return false;
    },
    addRes(label) {
      label.result.push({
        keyword: '',
        value: '',
        lawRes: []
      });
    },
    removeRes(label, index) {
      if (label.result.length === 1) {
        const filterIndex = this.filterList.findIndex(item => item === label);
        this.filterList.splice(filterIndex, 1);
      } else {
        label.result.splice(index, 1);
      }
    },
    removeFiled(label) {
      const key = findIndex(this.filterList, { key: label.key });
      key && key !== -1 && this.filterList.splice(key, 1);
    },
    isArrayCheck(arr) {
      if (arr) {
        return Array.isArray(arr);
      } else {
        return false;
      }
    },
    groupByKey(arr, key) {
      if (arr && key) {
        return groupBy(arr, key);
      } else {
        return [];
      }
    },
    showAllParaCheck(arr) {
      if (arr) {
        const hadRes = arr.filter(paraItem => {
          return paraItem.value;
        });
        return hadRes.length > 0;
      } else {
        return false;
      }
    },
    initFilterDefaultVal() {
      if (this.courseConditionArr.length < 1) {
        return;
      }
      const courseConditionArr = [...this.courseConditionArr];
      const addFiledList = [];

      const curFilterArr = this.justFilterEdit ? this.filterList : [...this.filterList, ...this.filedList];

      curFilterArr.forEach((v, idx) => {
        const filterItem = find(courseConditionArr, { name: v.name });
        if (filterItem) {
          v.value = cloneDeep(filterItem.value);
          v.showValue = cloneDeep(filterItem.showValue);
          v.result = cloneDeep(filterItem.result);
          if (['全文检索', '引用法条'].includes(filterItem.name)) {
            v.type = filterItem.type || 'and';
          }

          if (idx >= curFilterArr) {
            addFiledList.push(v);
          }
        }
      });
      this.filterList.push(...addFiledList);
    },
    getQuery() {
      let query = {
        contentConditionList: []
      };

      if (sysCaseWays.includes(this.instrumentType)) {
        query = {
          ...query,
          search_type: this.instrumentType === '检察文书' ? 5 : 4,
          ranges: [],
          not_paragraphs: [],
          paragraphs: [],
          should_paragraphs: [],
          identities: [],
          not_stories: [],
          should_stories: [],
          stories: [],
          prop: {},
          query_string: {},
          props: {},
          propsLevel: {},
          split_value: {}
        }
      }
      
      this.filterList.forEach(filterItem => {
        if (filterItem.isAdministrativeDoc) {
          if (filterItem.inputType === 'districtIds') {
            if ((filterItem.value || []).length > 0) {
              query[filterItem.key] = filterItem.value.map(o => o.id);
            }
          } else if (filterItem.inputType === 'input') {
            if (filterItem.value) {
              query[filterItem.key] = filterItem.value;
            }
          } else if (filterItem.inputType === 'select') {
            if ((filterItem.value || []).length > 0) {
              query[filterItem.key] = filterItem.value;
            }
          } else if (filterItem.inputType === 'date') {
            if (filterItem.value[0]) {
              query[`${filterItem.key}Start`] = filterItem.value[0];
            }
            if (filterItem.value[1]) {
              query[`${filterItem.key}End`] = filterItem.value[1] + dayUnixValue - 1;
            }
          }
          return;
        }

        if (['全文检索'].includes(filterItem.name)) {
          const filterArr = [];
          let topType = 'must';
          filterItem.result.forEach(paragraphItem => {
            if (paragraphItem.value || paragraphItem.result.length) {
              // 包含高级检索和 输入框直接输入的
              const resItem = this.fullTextArgHandel(paragraphItem);
              if (!filterItem.bySearchInput && !filterArr.length) {
                topType = filterItem.type;
              }
              const fullTextItem = {
                type: paragraphItem.type || 'must', //兼容输入框插入的条件
                keyword: 'group',
                search_limit: '同篇',
                word: filterItem.word || '',
                field: '',
                children: resItem
              };

              filterArr.push(fullTextItem);
            }
          });

          if (filterArr.length) {
            query.contentConditionList.push({
              type: topType,
              keyword: 'group',
              search_limit: '同篇',
              word: '',
              field: '',
              children: filterArr
            });
          }
        } else if (['引用法条'].includes(filterItem.name)) {
          const contentQuery = {
            bool: {}
          };
          const key = filterItem.type == 'or' ? 'should' : 'must';
          contentQuery.bool[key] = [];
          const contentQueryArr = contentQuery.bool[key];
          filterItem.result.forEach(paragraphItem => {
            if (filterItem.name === '引用法条' && (paragraphItem.value || paragraphItem.keyword)) {
              contentQueryArr.push({
                regexp: {
                  'lawinfo.sentence': `.*?${paragraphItem.keyword}.*?${paragraphItem.value.slice(
                    0,
                    paragraphItem.value.indexOf('条') + 1
                  )}.*?`
                }
              });
            }
          });

          query.paragraphs.push(contentQuery);
        } else if (['fullreason'].includes(filterItem.key)) {
          // 兼容搜索框中插入的 结果中检索
          if (!query.propsLevel[filterItem.key]) {
            query.propsLevel[filterItem.key] = {
              default_operator: filterItem.type,
              keys: []
            };
          }
          query.propsLevel[filterItem.key].keys.push(
            ...filterItem.result
              .filter(o => o.value.length)
              .map(item => {
                return {
                  value: item.value.map(i => i.id)
                };
              })
          );
        } else if (['full_base_court', 'full_procedureType'].includes(filterItem.key)) {
          // 兼容搜索框中插入的 结果中检索
          if (!query.propsLevel[filterItem.key]) {
            query.propsLevel[filterItem.key] = {
              default_operator: 'OR',
              keys: [
                {
                  value: []
                }
              ]
            };
          }
          query.propsLevel[filterItem.key].keys[0].value.push(...filterItem.value.map(item => item.id));
        } else if (['base_courtLevel'].includes(filterItem.key) && filterItem.value.length) {
          query.props[filterItem.key] = filterItem.value;
        } else if (['base_caseType', 'base_nature'].includes(filterItem.key)) {
          if (!filterItem.value.length) {
            return;
          }
          if (!query.props[filterItem.key]) {
            query.props[filterItem.key] = [];
          }
          query.props[filterItem.key].push(...filterItem.value);
        } else if (['base_title'].includes(filterItem.key) && filterItem.value) {
          query.query_string[filterItem.key] = filterItem.value;
        } else if (['base_caseNumber'].includes(filterItem.key) && filterItem.value) {
          query.props[filterItem.key] = filterItem.value.split('|');
        } else if (filterItem.key === 'judgementDate') {
          const rangesQuery = {};
          if (filterItem.value[0]) {
            rangesQuery.gte = moment(filterItem.value[0]).valueOf();
          }
          if (filterItem.value[1]) {
            rangesQuery.lte = moment(filterItem.value[1]).valueOf();
          }
          if (filterItem.value[0] || filterItem.value[1]) {
            query.ranges.push({
              range: 'judgementDate',
              query: rangesQuery
            });
          }
        } else if (filterItem.key === 'province_city') {
          filterItem.value.forEach(provinceCityItem => {
            if (provinceCityItem.length === 1) {
              if (!query.props.base_province) {
                query.props.base_province = [];
              }
              query.props.base_province.push(provinceCityItem[0]);
            }
            if (provinceCityItem.length === 2) {
              if (!query.props.base_city) {
                query.props.base_city = [];
              }
              query.props.base_city.push(provinceCityItem[1]);
            }
          });
        } else if (filterItem.key === 'mulit_personal_crime') {
          const { singlePersonal, mulitPersonal, singleCrime, mulitCrime } = filterItem.value;
          if (singlePersonal && mulitPersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                gte: 1
              }
            });
          } else if (singlePersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                lte: 1,
                gte: 1
              }
            });
          } else if (mulitPersonal) {
            query.ranges.push({
              range: 'defendantSize',
              query: {
                gte: 2
              }
            });
          }
          if (singleCrime && mulitCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                gte: 1
              }
            });
          } else if (singleCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                lte: 1,
                gte: 1
              }
            });
          } else if (mulitCrime) {
            query.ranges.push({
              range: 'crime_reason_length',
              query: {
                gte: 2
              }
            });
          }
        } else if (filterItem.key === 'version' && filterItem.value) {
          if (query.split_value) {
            query.split_value[filterItem.key] = filterItem.value;
          } else {
            query.version = filterItem.value
          }
        } else if (['律师', '律所', '当事人信息', '审判人员', '案情特征'].includes(filterItem.name)) {
          if (filterItem.value) {
            query.identities.push({
              userType: filterItem.name,
              name: filterItem.value
            });
          }
        }
      });
      return query;
    },
    fullTextArgHandel(item) {
      const arr = [];
      if (item.result && item.result.length) {
        item.result.forEach(i => {
          arr.push(...this.fullTextArgHandel(i));
        });
      } else {
        if (item.value) {
          const pushItem = {
            type: item.type,
            keyword: item.result && item.result.length ? 'group' : 'search',
            search_limit: item.searchLimit || '同篇',
            field: item.keyword || 'para_content'
          };
          if (item.value instanceof Array) {
            pushItem.terms = item.value.map(i => i.id);
            pushItem.word = '';
          } else {
            pushItem.word = item.value;
          }
          arr.push(pushItem);
        }
      }
      return arr;
    },
    async fetchAllCaseTotal() {
      try {
        const res = await services.courseware.getCaseCount({});
        this.totalCount = res.total;
      } catch (err) {
        this.$error(err);
      }
    },
    async dataFilterHandle() {
      const caseQuery = this.getQuery();
      try {
        this.countLoading++;
        this.countLoadingIdx++;

        const curCountLoadingIdx = this.countLoadingIdx;
        let count = 0;

        if (sysCaseWays.includes(this.instrumentType)) {
          const res = await services.courseware.getCaseCount({
            size: 0,
            ...caseQuery
          });
          count = res.total;
        } else {
          count = await services.courseware.fetchAdministrativeCount(caseQuery);
        }

        if (this.countLoadingIdx === curCountLoadingIdx) {
          this.filterCount = count;
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.countLoading--;
      }
    },
    removeFilter({ filterItem, contentArr, id }) {
      if (['全文检索'].includes(filterItem.name)) {
        const newFilterItem = cloneDeep(filterItem);
        newFilterItem.result = newFilterItem.result.filter(i => {
          i.result = i.result.filter(o => {
            return o.id !== id;
          });
          return i.id !== id;
        });
        if (newFilterItem.result.length === 1) {
          // 删除剩余一项时需要插回子集
          newFilterItem.result.push(filterItem.fetchChildInfo());
        }
        filterItem.result = newFilterItem.result;
      } else if (['案由'].includes(filterItem.name)) {
        filterItem.resetFunc.call(filterItem);
      } else if (['引用法条'].includes(filterItem.name)) {
        const removeKeys = contentArr.map(item => item.keyword);
        filterItem.result = filterItem.result.filter(item => !removeKeys.includes(item.keyword));
        if (filterItem.result.length === 0) {
          filterItem.result.push({ value: '', keyword: '' });
        }
      } else if (filterItem.inputType === 'province_city_cascader') {
        filterItem.data = cloneDeep(provinceJson);
        filterItem.value = [];
      } else if (filterItem.inputType === 'mulit_personal_crime') {
        filterItem.value = {
          singlePersonal: false,
          mulitPersonal: false,
          singleCrime: false,
          mulitCrime: false
        };
      } else if (filterItem.inputType === 'date') {
        filterItem.value = [];
      } else if (filterItem.key === 'base_caseType') {
        filterItem.value = [];
        const item = find(this.filterList, { name: '审理程序' });
        item.value = [];
        this.$refs.full_procedureType[0].initValue();
      } else if (['full_procedureType', 'full_base_court'].includes(filterItem.key)) {
        filterItem.value = [];
        this.$refs[filterItem.key][0].initValue();
        filterItem.value = [];
      } else {
        filterItem.value = '';
      }
    },
    async fetchCaseTypeList() {
      try {
        const queryInfo = { term: { 'typename.keyword': '案件类型' } };

        const { hits } = await services.courseware.getCourseCrime({
          size: 5000,
          query: {
            bool: {
              must: [{ ...queryInfo }]
            }
          },
          sort: [{ sort: 'desc' }]
        });

        const caseTypeList = [];
        for (const crimeItem of hits.hits) {
          caseTypeList.push({
            ...crimeItem._source,
            id: crimeItem._id
          });
        }
        this.selectRelationOptions.base_caseType = Object.freeze(arrayToTree(caseTypeList));
      } catch (err) {
        this.$error(err);
      }
    },
    async fetchLawData() {
      try {
        const { category } = await services.courseware.getLawTree();
        category.buckets.forEach(categoryItem => {
          this.$set(categoryItem, 'id', 'category_' + uniqueId());
          categoryItem.title.buckets.forEach(lawItem => {
            this.$set(lawItem, 'id', 'law_' + uniqueId());
          });
        });
        this.selectRelationOptions.lawViews = category.buckets;
      } catch (err) {
        this.$error(err);
      }
    },
    async fetchOrgTypeNames() {
      try {
        const result = await services.courseware.getCourseCrime({
          size: 5000,
          query: {
            bool: {
              must: [{ term: { 'typename.keyword': '机关类型' } }]
            }
          },
          sort: [
            {
              sort: 'desc'
            },
            {
              _id: 'asc'
            }
          ]
        });
        this.selectRelationOptions.orgTypeNames = result.hits.hits.map(o => o._source.name);
      } catch (err) {
        this.$error(err);
      }
    },
    handleCrimeNodeClick(data) {
      const crimeItem = find(this.filterList, { name: '案由' });
      crimeItem.value.push(data.name);
      this.showCrimeTree = false;
    },
    showTipHandle() {
      if (!this.filterCount) {
        this.$message.warning('当前课题案件数筛选结果为0条，请更改筛选条件再创建');
        return;
      }
      this.payModal = {
        lockTotal: this.courseLockSize,
        caseTotal: this.filterCount,
        show: true
      };
    },
    saveCoursewareHandle({ orderId, callback }) {
      this.saveCoursewareLoading = true;
      const query = this.getQuery();
      const filterList = this.filterList
        .filter(v => {
          if (v.name === '全文检索') {
            return true;
          }
          if (v.inputType === 'mulit_personal_crime') {
            const haveCheck = Object.keys(v.value).some(key => v.value[key]);
            return haveCheck;
          }
          let haveResult = false;
          if (v.name === '引用法条') {
            haveResult = (v.result || []).some(resultItem => resultItem.value || resultItem.keyword);
          } else {
            haveResult = (v.result || []).some(resultItem => resultItem.value);
          }
          if (haveResult) {
            return true;
          }
          return (v.value || '').length > 0;
        })
        .map(v => {
          const info = { ...v };
          if (info.data) {
            delete info.data;
          }
          if ((info.result || []).length > 0) {
            info.result = info.result.map(resultItem => {
              if (resultItem.lawRes) {
                return { ...resultItem, lawRes: [] };
              } else {
                return resultItem;
              }
            });
          }
          return info;
        });
      this.$emit('saveCoursewareHandle', {
        orderId,
        callback,
        query: { query: { ...query } },
        condition: filterList,
        instrumentType: this.instrumentType
      });
    },
    addFields(item) {
      const fieldModel = this.hadFileds(item);
      !fieldModel && this.filterList.push(item);
    },
    hadFileds(item) {
      const fieldModel = find(this.filterList, { name: item.name });
      return fieldModel;
    },
    changeCascaderHandle(type) {
      const item = this.filterList.find(filterItem => filterItem.key === type);
      const value = [...item.value];
      const newValue = [];
      const provinceEnum = {};
      value.forEach(valItem => {
        if (valItem.length === 1) {
          provinceEnum[valItem[0]] = true;
        }
      });
      value.forEach(valItem => {
        if (valItem.length === 1) {
          newValue.push(valItem);
        }
        if (valItem.length === 2 && !provinceEnum[valItem[0]]) {
          newValue.push(valItem);
        }
      });
      item.data = cloneDeep(provinceJson).map(provinceItem => {
        let disabled = true;
        if (!provinceEnum[provinceItem.name]) {
          disabled = false;
        }
        return {
          ...provinceItem,
          children: (provinceItem.children || []).map(childItem => {
            return { ...childItem, disabled };
          })
        };
      });
      item.value = newValue;
      this.multSelectHandle(type);
    },
    multSelectHandle(type) {
      const filterItemEL = this.$refs[type][0];
      filterItemEL.blur && filterItemEL.blur();
    },
    async remoteMethod(query, val) {
      try {
        if (query !== '') {
          // const lawItem = find(this.filterList, { name: '引用法条' });
          const res = await services.courseware.getFilterLaw({
            title: val.keyword,
            search: query
          });
          const lawRes = [];
          res.hits.forEach(v => {
            lawRes.push({ id: v._id, highlight: v.highlight, ...v._source });
          });
          val.lawRes = lawRes;
        }
      } catch (err) {
        this.$error(err);
      }
    },
    refreshFilterOptions() {
      const sysDataFlagKey = {
        裁判文书: 'isBaseNatureCase',
        检察文书: 'isProcuratorial',
        行政处罚文书: 'isAdministrativeDoc'
      };

      const formatFn = list => {
        return list.filter(i => {
          if (i.isAdmin) {
            return this.isAdmin;
          }
          if (i.isCommon) {
            return true;
          }
          const flagKey = sysDataFlagKey[this.instrumentType];
          return !!(flagKey && i[flagKey])
        }).map(i => {
          return { ...i, uniqueId: `${Date.now()}_${uniqueId()}` };
        })
      }

      this.casePickType = '';

      this.filterList = formatFn([
        {
          name: '全文检索',
          inputType: 'matchSelect',
          mulits: true,
          isCommon: true,
          type: 'must',
          formatter: function(val) {
            this.result.push(val);
          },
          result: [
            {
              id: `${Date.now()}_${uniqueId()}`,
              value: '',
              showValue: [],
              keyword: 'para_content',
              searchLimit: '同篇',
              searchLimitDis: false,
              result: [],
              type: 'must'
            },
            {
              id: `${Date.now()}_${uniqueId()}`,
              value: '',
              showValue: [],
              keyword: 'para_content',
              searchLimit: '同篇',
              searchLimitDis: false,
              result: [],
              type: 'must'
            }
          ],
          addRes: function() {
            this.result.push(this.fetchChildInfo());
          },
          fetchChildInfo() {
            return {
              id: `${Date.now()}_${uniqueId()}`,
              value: '',
              showValue: [],
              keyword: '',
              searchLimit: '同篇',
              searchLimitDis: false,
              result: [],
              type: 'must'
            };
          },
          resetFunc: function() {
            this.result = [this.fetchChildInfo(), this.fetchChildInfo()];
          }
        },
        {
          name: '案件类型',
          inputType: 'select',
          mulits: false,
          isBaseNatureCase: true,
          value: [],
          data: [],
          key: 'base_caseType'
        },
        {
          name: '审理程序',
          inputType: 'select',
          mulits: false,
          isBaseNatureCase: true,
          value: [],
          showValue: [],
          data: ['一审', '二审', '再审', '其他'],
          key: 'full_procedureType',
          checkAllName: ['含下级'],
          formatter: function(value, showValue) {
            this.value = value;
            this.showValue = showValue || value;
          },
          resetFunc: function() {
            this.value = [];
            this.showValue = [];
          }
        },
        {
          name: '案由',
          subName: ['聚合案由'],
          inputType: 'matchSelect',
          mulits: true,
          isBaseNatureCase: true,
          isProcuratorial: true,
          type: 'and',
          result: [getFullReasonChild(), getFullReasonChild()],
          value: [],
          showValue: [],
          key: 'fullreason',
          checkAllName: ['含下级'],
          formatter: function(value, showValue) {
            this.result = [
              {
                value: value,
                showValue: showValue || value
              }
            ];
          },
          resetFunc: function() {
            this.result = [getFullReasonChild(), getFullReasonChild()];
          },
          addRes: function() {
            this.result.push(getFullReasonChild());
          },
          removeRes: function(index) {
            this.result.splice(index, 1);
          }
        },
        {
          name: '文书日期',
          inputType: 'date',
          mulits: false,
          isBaseNatureCase: true,
          isProcuratorial: true,
          value: [],
          key: 'judgementDate',
          tipText: ''
        },
        {
          name: '文书性质',
          inputType: 'select',
          mulits: false,
          isBaseNatureCase: true,
          isProcuratorial: true,
          value: [],
          data: [],
          key: 'base_nature'
        },
        {
          name: '当事人名称',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'counterpart',
          isAdministrativeDoc: true,
          placeholder: '请输入当事人名称'
        },
        {
          name: '对象类型',
          inputType: 'select',
          mulits: false,
          value: '',
          data: ['机构', '个人', '双罚'],
          key: 'counterpartTypes',
          isAdministrativeDoc: true,
          placeholder: '请选择'
        },
        {
          name: '实施机关',
          inputType: 'select',
          mulits: false,
          value: '',
          data: [],
          key: 'orgTypeNames',
          isAdministrativeDoc: true,
          placeholder: '请选择'
        },
        {
          name: '处罚种类',
          inputType: 'select',
          mulits: false,
          value: '',
          data: [
            '警告、通报批评',
            '罚款、没收违法所得、没收非法财物',
            '暂扣许可证件、降低资质等级、吊销许可证件',
            '限制开展生产经营活动、责令停产停业、责令关闭、限制从业',
            '行政拘留',
            '法律、行政法规规定的其他行政处罚'
          ],
          key: 'penaltyCategories',
          isAdministrativeDoc: true,
          placeholder: '请选择'
        },
        {
          name: '处罚日期',
          inputType: 'date',
          mulits: false,
          isAdministrativeDoc: true,
          value: [],
          key: 'judgeDate',
          tipText: ''
        },
        {
          name: '处罚依据',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'penaltyBasis',
          isAdministrativeDoc: true,
          placeholder: '请输入处罚依据'
        },
        {
          name: '执法地域范围',
          inputType: 'districtIds',
          mulits: false,
          value: '',
          data: [],
          key: 'districtIds',
          isAdministrativeDoc: true,
          placeholder: '请选择'
        },
        {
          name: '机关执法级别',
          inputType: 'select',
          mulits: false,
          value: '',
          data: ['中央', '省级', '市级', '区县级'],
          key: 'districtLevelStrs',
          isAdministrativeDoc: true,
          placeholder: '请选择'
        },
      ]);

      this.filedList = formatFn([
        {
          name: '标题',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'base_title',
          edit: true,
          isBaseNatureCase: true,
          placeholder: '请输入标题'
        },
        {
          name: '案号',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'base_caseNumber',
          edit: true,
          isBaseNatureCase: true,
          isProcuratorial: true,
          placeholder: '请输入案号'
        },
        {
          name: '省市',
          inputType: 'province_city_cascader',
          mulits: false,
          value: [],
          data: cloneDeep(provinceJson),
          isProcuratorial: true,
          optionProps: {
            expandTrigger: 'hover',
            multiple: true,
            checkStrictly: true,
            value: 'name',
            label: 'name'
          },
          key: 'province_city',
          edit: true
        },
        {
          name: '引用法条',
          inputType: 'matchSelect',
          mulits: true,
          key: 'lawinfo',
          isBaseNatureCase: true,
          type: 'and',
          result: [
            {
              value: '',
              keyword: '',
              lawRes: []
            }
          ],
          edit: true
        },
        {
          name: '共同犯罪',
          inputType: 'mulit_personal_crime',
          key: 'mulit_personal_crime',
          edit: true,
          isBaseNatureCase: true,
          value: {
            singlePersonal: false,
            mulitPersonal: false,
            singleCrime: false,
            mulitCrime: false
          }
        },
        {
          name: '地域及法院',
          subName: ['地区分布图'],
          inputType: 'full_base_court',
          mulits: false,
          isBaseNatureCase: true,
          value: [],
          showValue: [],
          key: 'full_base_court',
          edit: true,
          checkAllName: ['所有法院', '本院及辖区法院'],
          formatter: function(value, showValue) {
            this.value = value;
            this.showValue = showValue || value;
          },
          resetFunc: function() {
            this.value = [];
            this.showValue = [];
          }
        },
        {
          name: '法院层级',
          inputType: 'select',
          mulits: false,
          isBaseNatureCase: true,
          value: [],
          data: ['最高人民法院', '高级人民法院', '中级人民法院', '基层人民法院'],
          key: 'base_courtLevel',
          edit: true
        },
        {
          name: '案件名称',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'title',
          edit: true,
          isAdministrativeDoc: true,
          placeholder: '请输入案件名称'
        },
        {
          name: '文号',
          inputType: 'input',
          mulits: false,
          value: '',
          key: 'caseNo',
          edit: true,
          isAdministrativeDoc: true,
          placeholder: '请输入文号'
        },
        {
          name: '版本号',
          key: 'version',
          inputType: 'version',
          value: '',
          placeholder: '版本号，以“|”分隔',
          edit: true,
          isAdmin: true
        }
      ]);
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-input--small .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.panel-item-warp {
  position: relative;
  left: -4px;
  flex: 1;
}

.course-create-input-popper {
  width: 450px !important;
  margin-left: -140px !important;

  .popper__arrow {
    margin-left: 230px;
  }
}
.cirme-input-popper {
  width: 540px !important;
}
.course-create-input-tip {
  .course-create-input-tip-title {
    font-size: 12px;
    color: rgba(#3d465a, 0.8);
    height: 30px;
    line-height: 30px;
  }
  .course-create-input-tip-item {
    font-size: 12px;
    color: #3d465a;
    height: 26px;
    line-height: 26px;
  }
}
</style>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  position: relative;
}
.course-panel {
  padding: 20px 190px 20px 40px;
  min-height: 420px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  .course-panel-body {
    color: #2c3443;
    .desc {
      margin-bottom: 18px;
      .label {
        font-size: 16px;
        margin-right: 10px;
      }
      .word {
        font-size: 12px;
        color: #77839e;
      }
    }
  }

  .course-panel-item {
    line-height: 35px;
    margin-bottom: 20px;
    $labelWidth: 90px;
    .label {
      width: $labelWidth;
      display: inline-block;
    }

    .course-panel-item-tip {
      margin-left: $labelWidth;
      font-size: 12px;
      color: rgba(119, 131, 158, 0.8);

      & > span {
        font-weight: 300;
      }
    }
    .operation {
      position: relative;
      top: 2px;
      font-size: 20px;
      color: #a0acc0;
      margin-right: 5px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
    .input {
      display: inline-block;

      .left-select {
        ::v-deep .el-input {
          input {
            border-right-width: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          .el-input__inner:focus {
            border-color: #dcdfe6 !important;
          }
          &.is-focus {
            input {
              border-color: #dcdfe6 !important;
            }
          }
        }
      }

      .right-select {
        // .el-input__inner:focus
        ::v-deep .el-input {
          input {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }
    &-wrapper {
      display: inline-block;

      .personal-crime-checkbox {
        width: 117.5px;
        line-height: 20px;
        margin: 0;
        margin-left: 10px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
    .crime-tree {
      position: relative;

      ::v-deep .crime-select {
        .el-select__tags {
          max-width: 350px !important;
        }
      }
      .crime-tree-btn {
        position: absolute;
        right: 10px;
        background-color: #fff;
        z-index: 10;
        height: 80%;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .crime-tree-panel {
        width: 100%;
        position: absolute;
        left: 0;
        border: 1px solid #d2d8e3;
        z-index: 99;
        background: #fff;
        max-height: 500px;
        overflow-y: auto;
      }
    }
  }
}
.course-panel-menu {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 57px;
  width: 190px;
  background-color: #f8fafd;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 10px;
  .menu-title {
    text-align: center;
    color: #3d465a;
    margin-bottom: 15px;
    font-size: 14px;
  }
  .new-filter-ul {
    text-align: center;
    .new-filter-item {
      display: inline-block;
      text-align: left;
      width: 116px;
      line-height: 28px;
      background: #f8fafd;
      border-radius: 4px;
      min-width: 90px;
      padding: 0 10px;
      margin: 8px 12px;
      color: #77839e;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0px 2px 4px 2px rgb(129 150 180 / 16%);
      & > span {
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
      &.disabled-filter-item {
        cursor: not-allowed;
        background-color: rgba(#c0ccda, 0.4);
        box-shadow: none;
      }
    }
  }
}
.panel-item-warp {
  position: relative;
  flex: 1;
  .text-group-type {
    position: absolute;
    left: -18px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    user-select: none;

    .group-type-btn {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .group-text {
        color: #999999;
        background-color: #f5f5f5;
        line-height: 20px;
        padding: 0 2px;

        &.active {
          color: #e42626;
          background-color: #ffeaea;
        }
      }

      &.not-allowed {
        cursor: not-allowed;
      }
    }
  }

  .line {
    display: inline-block;
    background: #ddd;
    width: 1px;
    height: 100%;
    position: absolute;
    left: -11px;
    top: 50%;
    transform: translateY(-50%);
    .line-item {
      contain: '';
      display: block;
      height: 1px;
      width: 10px;
      background: #ddd;
      position: relative;
    }
    .line-item-top {
      position: absolute;
      top: 0;
    }
    .line-item-bottom {
      position: absolute;
      bottom: 0;
    }
  }
}

.normal-footer {
  display: flex;
  line-height: 35px;
  justify-content: space-between;
  border-top: 1px solid #d2d8e3;
  padding: 10px 20px;
  .filter-count {
    border-left: 1px solid #d2d8e3;
    margin-left: 10px;
    padding-left: 10px;
    font-size: 14px;
    .blue {
      color: #409eff;
    }
    .green {
      color: #67c23a;
    }
    .red {
      color: #f56c6c;
    }
    .question-icon {
      color: rgba(#3d465a, 0.4);
      margin-left: 2px;
    }
  }
}

.condition-panel {
  .condition-item {
    display: inline-block;
    padding: 0 12px;
    line-height: 28px;
    color: #1991fb;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #1991fb;
    margin: 0 10px 10px 0;

    .close-btn {
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.province-city-cascader {
  .el-checkbox__input {
    &.is-disabled {
      .el-checkbox__inner {
        background-color: #fff;
        &::after {
          border-color: #dcdfe6;
          transform: rotate(45deg) scaleY(1);
        }
      }
    }
  }
}
</style>
